import { css } from 'linaria';
import React, { useState } from 'react';

type Props = React.DetailedHTMLProps<React.ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> & {
  fallback: React.ReactNode;
} & {
  fetchpriority?: 'high' | 'low' | 'auto';
};

export const ImagePlaceholder: React.FC<Props> = ({ fallback, ...props }) => {
  const [isError, setIsError] = useState(false);

  if (isError && fallback) {
    return <>{fallback}</>;
  }

  return <img className={imgClassName} onError={() => setIsError(true)} {...props} />;
};

const imgClassName = css`
  object-fit: contain;
  height: 100%;
  width: 100%;
`;
